export default __webpack_public_path__ + "static/predicting-failures-750b9ed9bf7e57c77ca8f247ae51594a.png";